<template>
    <div class="studyPlan">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'studyPlan',
    data(){
        return {

        }
    },
    created() {
    }


}
</script>

<style scoped lang="less">
.studyPlan {
    padding-left: 20px;
}
</style>
